import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { SettigsView } from '../../view/settings/SettigsView';
import { SettingsViewMobile } from '../../view/settings/SettingsViewMobile';

const events = [
	EVENTS.ERROR_PAGE,
	EVENTS.BONUS_ROUND_STATE,
	EVENTS.SETTINGS_UPDATE,
	EVENTS.MODAL
];
class SettingsController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		this.enabled = false;
		if (this.vc.infobuttons.getChildByName(this.config.modal)) {
			this.item = this.vc.infobuttons.getChildByName(this.config.modal);
			this.item.handler = this.handler;
			this.addEventListeners();
			window.addEventListener(EVENTS.BONUS_BUY, this, false);
			this.checkBonus();
		} else {
			throw new Error(
				'SettingsController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	checkBonus() {
		if (GameConfigs.config.hasbonus) {
			this.item.interactive = false;
			// window.removeEventListener('keydown', this, false);
		} else {
			this.item.interactive = true;
		}
	}

	addEventListeners() {
		events.forEach((event) => window.addEventListener(event, this, false));
		if (
			GameConfigs.settings.keyboard_shortcuts &&
			!window.isMobile &&
			!window.isTablet
		) {
			this.enabled = true;
			window.addEventListener('keydown', this, false);
		}
	}
	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.ERROR_PAGE:
				if (evt.detail.error) {
					this.removeEvents();
					window.removeEventListener(EVENTS.BONUS_BUY, this, false);
				}
				break;
			case EVENTS.BONUS_BUY:
				if (evt.detail.bonus) {
					this.item.interactive = false;
					// window.removeEventListener('keydown', this, false);
				} else {
					this.item.interactive = true;
					// window.addEventListener('keydown', this, false);
				}
				break;
			case EVENTS.BONUS_ROUND_STATE:
				if (evt.detail.state === 'started') {
					this.item.interactive = true;
					// window.addEventListener('keydown', this, false);
				}
				break;
			case 'keydown':
				if (evt.keyCode === 83) {
					if (this.enabled && this.item.interactive) {
						this.handler();
					}
				}
				break;
			case EVENTS.SETTINGS_UPDATE:
				if (window.isMobile || window.isTablet) return;
				if (evt.detail.data.keyboard_shortcuts === undefined) return;
				if (evt.detail.data.keyboard_shortcuts) {
					if (this.enabled) return;
					this.enabled = true;
					window.addEventListener('keydown', this, false);
				} else {
					this.enabled = false;
					window.removeEventListener('keydown', this, false);
				}
				break;
			case EVENTS.MODAL:
				if (!window.isMobile && !window.isTablet) return;
				if (
					evt.detail.modal === 'settings' ||
					evt.detail.modal === 'quest' ||
					evt.detail.modal === 'quest_claim' ||
					GameConfigs.bonusBuy
				) {
					this.item.interactive = false;
				} else this.item.interactive = true;
				break;
			default:
				break;
		}
	}

	handleModal(e) {
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: e });
	}

	handler = () => {
		if (
			GameConfigs.disabled.settings ||
			(GameConfigs.isFreeSpin && GameConfigs.freeSpinLocal.show)
		)
			return;
		if (GameConfigs.modal === 'settings') {
			GameConfigs.uiComponent[this.config.item].CloseController.closeHandler();
			this.handleModal('');
		} else if (GameConfigs.modal === 'bonus_game_finish') {
			setTimeout(() => {
				this.openSettings();
			}, 50);
		} else this.openSettings();
	};

	openSettings() {
		this.handleModal('settings');
		// this.item.interactive = false
		// this.vc.ui_info.item.interactive = false
		// this.vc.ui_fullscreen.item.interactive = false
		GameConfigs.uiComponent.addView(
			window.isMobile || window.isTablet ? SettingsViewMobile : SettigsView
		);
		GameConfigs.uiComponent[this.config.item].CloseController.onClose(() => {
			// this.item.interactive = true
			// GameConfigs.uiComponent.removeView(GameConfigs.uiComponent[this.config.item])
			// delete GameConfigs.uiComponent[this.config.item]
		});
	}
	removeEvents() {
		this.item.interactive = false;
		events.forEach((event) => window.removeEventListener(event, this, false));
		window.removeEventListener('keydown', this, false);
	}
}

export default SettingsController;
